import { Outlet } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { AdminSidebar } from '../components/layout/AdminSidebar';
import { useAuth } from '../hooks/useAuth';
import './AdminLayout.css';

const ROLE_LABELS = {
  super_administrateur: 'Super administrateur',
  admin: 'Administrateur',
  manager: 'Manager',
  editeur: 'Éditeur',
  lecture: 'Lecture seule',
};

export function AdminLayout() {
  const { user, logout } = useAuth();
  const prenom = user?.prenom || user?.email?.split('@')[0] || 'Utilisateur';
  const initiale = prenom.charAt(0).toUpperCase();
  const role = ROLE_LABELS[user?.role] || user?.role;

  return (
    <div className="admin-layout">
      <AdminSidebar />

      <div className="admin-layout__content">
        <header className="admin-layout__topbar">
          <div className="admin-layout__user">
            <span className="admin-layout__avatar">{initiale}</span>
            <div className="admin-layout__user-info">
              <span className="admin-layout__user-name">{prenom}</span>
              {role && <span className="admin-layout__user-role">{role}</span>}
            </div>
          </div>

          <button type="button" className="admin-layout__logout" onClick={logout}>
            <LogOut size={16} />
            Déconnexion
          </button>
        </header>

        <main className="admin-layout__main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
